/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../core/components/NavBar";
import UserContext from "../core/UserContext";
import currencyFormatter from "currency-formatter";
import "./Application.css";
import Moment from "moment";
import axios from "../api/axios";
import {
  getTotalPremiumWithAddOnValue,
  updateObjectInArray,
  getUserDataFromLocalStorage,
  getPolicyClassName,
  log,
} from "../core/utils";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { getLives } from "../quotation-view/QuotationView";
import UsePagination from "../core/components/usePagination";
import apiRoutes from "../api/apiRoutes";

const Application = () => {
  const { userData } = useContext(UserContext);
  const userDataStorage = getUserDataFromLocalStorage();
  const axiosPrivate = useAxiosPrivate(userDataStorage);
  const navigate = useNavigate();
  const [applications, setApplications] = useState();
  const [loading, setLoading] = useState(false);
  const [downloadingQuotation, setDownloadingQuotation] = useState([]);
  const [paginatedLimit, setPaginatedLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [state, setState] = useState({
    firstname: "",
    lastname: "",
    email: "",
    title: "",
    birth: "",
    phoneNumber: "",
  });

  const primaryAction = async (application) => {
    if (application.status === "underwriting") {
      navigate(`/underwriting/${application.id}/main-life`);
    } else if (application.status === "kyc") {
      navigate(`/client-kyc/${application?.user?.id}/${application.id}/main`);
    } else if (application.status === "review") {
      navigate(`/review/${application.id}`);
    } else if (application.status === "firstpayment") {
      navigate(`/quotations/${application.id}/first-payment`);
    }
  };

  const getApplications = useCallback(async () => {
    const url = process.env.REACT_APP_API_URL + apiRoutes.applications;
    setLoading(true);

    try {
      const response = await axiosPrivate.get(url, {
        params: {
          pageSize: paginatedLimit,
          page: currentPage,
        },
      });
      setLoading(false);
      if (response.data.success === true) {
        let filteredApplications = response.data.data
          .filter(
            (item) => item.status !== "initial" && item.status !== "accepted",
          )
          .sort((a, b) => b.createdAt.localeCompare(a.createdAt));

        const filteredTotal = filteredApplications.length;
        setTotalItems(filteredTotal);
        setTotalPages(Math.ceil(filteredTotal / paginatedLimit));

        let downloadingSpinners = [];
        const processedApplications = filteredApplications.map(
          (application, index) => {
            downloadingSpinners.push({ index, status: false });
            application.quotationFormData = JSON.parse(
              application.quotationFormData,
            );
            application.lives = getLives(application);
            return application;
          },
        );

        setDownloadingQuotation(downloadingSpinners);
        setApplications(processedApplications);
      }
    } catch (error) {
      setLoading(false);
      log(error);
    }
  }, [paginatedLimit, currentPage, axiosPrivate]);

  const getQuotationLinkAndDownload = async (_quotation, index) => {
    const url =
      process.env.REACT_APP_API_URL +
      `/quotation/user/generate-pdf/${_quotation.id}`;

    try {
      setDownloadingQuotation(
        updateObjectInArray(downloadingQuotation, "index", index, {
          index,
          status: true,
        }),
      );
      const response = await axiosPrivate.get(url);

      if (response.data.success === true) {
        await new Promise((r) => setTimeout(r, 3000));
        const fileResponse = await axios({
          responseType: "blob",
          url: response.data.data.pdfLink,
          method: "GET",
        });
        setDownloadingQuotation(
          updateObjectInArray(downloadingQuotation, "index", index, {
            index,
            status: false,
          }),
        );
        const url = window.URL.createObjectURL(fileResponse.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "quotation.pdf");
        link.click();
      } else {
        setDownloadingQuotation(
          updateObjectInArray(downloadingQuotation, "index", index, {
            index,
            status: false,
          }),
        );
      }

      log(response);
    } catch (error) {
      setDownloadingQuotation(
        updateObjectInArray(downloadingQuotation, "index", index, {
          index,
          status: false,
        }),
      );
      log(error);
    }
  };

  const handlePageChange = useCallback((newPage) => {
    setCurrentPage(newPage);
  }, []);

  const handleLimitChange = useCallback((newLimit) => {
    setPaginatedLimit(Number(newLimit));
    setCurrentPage(1);
  }, []);

  useEffect(() => {
    const data = getUserDataFromLocalStorage();
    getApplications();
    const firstname = data ? data?.data?.name?.split(" ")[0] : "";
    const lastname = data ? data?.data?.name?.split(" ")[1] : "";
    const email = data ? data?.data?.email : "";
    const title = data ? data?.data?.title : "";
    const phoneNumber = data ? data?.data?.phoneNumber : "";
    const gender = data ? data?.data?.gender : "";
    const birth = data ? new Moment(data?.data?.birth) : "";
    const country = data ? data?.data?.country : "";

    setState({
      firstname,
      lastname,
      title,
      email,
      phoneNumber,
      gender,
      birth,
      country,
    });
  }, [getApplications]);

  return (
    <>
      <Navbar
        name={
          userData
            ? `${userData?.data?.firstname} ${userData?.data?.lastname}`
            : ""
        }
      />
      <div className="containerx tw-px-3 sm:tw-px-5 tw-w-full tw-max-w-7xl tw-mx-auto">
        <div
          className="mt-4 d-flex justify-content-between align-items-center p-4 px-5 text-white ila-bg"
          style={{ borderRadius: 2 }}
        >
          <h4 className="mb-0 tw-text-xl tw-font-semibold">Applications</h4>
        </div>

        {loading && (
          <div
            style={{ marginTop: 150 }}
            className="d-flex flex-column justify-content-center align-items-center"
          >
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div>Please wait...</div>
          </div>
        )}

        {applications && (
          <div className="tw-w-full tw-overflow-x-auto">
            <table
              style={{ padding: "20px !important" }}
              className="table tw-table-auto tw-whitespace-nowrap tw-min-w-full"
            >
              <thead className="tw-font-bold tw-text-black">
                <tr>
                  <th scope="col">Temporal ID</th>
                  <th scope="col">Contract Parties</th>
                  <th scope="col">Product</th>
                  <th scope="col">Sum Assured</th>
                  <th scope="col">Premium</th>
                  <th scope="col">Status</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody className="tw-text-black">
                {(applications || []).map((application, index) => {
                  const premium = application.premiumAmount;
                  return (
                    <tr key={index}>
                      <td scope="row">{application.temporaryId}</td>
                      <td>{application.lives}</td>
                      <td>
                        {getPolicyClassName(
                          application,
                          application.quotationFormData.loan_plan,
                        )}
                      </td>
                      <td>
                        {currencyFormatter.format(
                          parseFloat(
                            application.quotationFormData.initial_sum_assured,
                          ),
                          { symbol: "Rs " },
                        )}
                      </td>
                      <td>
                        {currencyFormatter.format(parseFloat(premium), {
                          symbol: "Rs ",
                        })}
                      </td>
                      <td>{application.status}</td>
                      <td>
                        <a
                          className="btn btn-sm ila-action-link"
                          onClick={() => {
                            getQuotationLinkAndDownload(application, index);
                          }}
                        >
                          {downloadingQuotation[index]?.status && (
                            <span
                              className="spinner-border spinner-border-sm me-1"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          )}
                          Download
                        </a>
                        &nbsp;
                        <a
                          className="btn btn-sm ila-action-link"
                          onClick={() => {
                            if (!application.paymentStatus) {
                              primaryAction(application);
                            } else {
                              navigate("/application-in-review");
                            }
                          }}
                        >
                          Continue
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <UsePagination
              pgdrop="tw-hidden"
              limit={paginatedLimit}
              total={totalItems}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onLimitChange={handleLimitChange}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Application;
